<script lang="ts">
// BETA-CLEANUP: delete this file and its spec once Vue 3 is the only app
import Vue, { CreateElement, RenderContext, VNode } from 'vue';

interface IProps {
  size: number;
}

// Phosphor "rocket-launch" duotone (MIT, phosphoricons.com). Not an MDI icon on purpose: the sparkles
// MDI offers are already the AI assistant's mark. Painted in currentColor, so it takes the parent's text colour.
const SECONDARY_PATH = 'M184,120v61.65a8,8,0,0,1-2.34,5.65l-34.35,34.35a8,8,0,0,1-13.57-4.53L128,176ZM136,72H74.35a8,8,0,0,0-5.65,2.34L34.35,108.69a8,8,0,0,0,4.53,13.57L80,128ZM40,216c37.65,0,50.69-19.69,54.56-28.18L68.18,161.44C59.69,165.31,40,178.35,40,216Z';
const PRIMARY_PATH = 'M223.85,47.12a16,16,0,0,0-15-15c-12.58-.75-44.73.4-71.41,27.07L132.69,64H74.36A15.91,15.91,0,0,0,63,68.68L28.7,103a16,16,0,0,0,9.07,27.16l38.47,5.37,44.21,44.21,5.37,38.49a15.94,15.94,0,0,0,10.78,12.92,16.11,16.11,0,0,0,5.1.83A15.91,15.91,0,0,0,153,227.3L187.32,193A15.91,15.91,0,0,0,192,181.64V123.31l4.77-4.77C223.45,91.86,224.6,59.71,223.85,47.12ZM74.36,80h42.33L77.16,119.52,40,114.34Zm74.41-9.45a76.65,76.65,0,0,1,59.11-22.47,76.46,76.46,0,0,1-22.42,59.16L128,164.68,91.32,128ZM176,181.64,141.67,216l-5.19-37.17L176,139.31Zm-74.16,9.5C97.34,201,82.29,224,40,224a8,8,0,0,1-8-8c0-42.29,23-57.34,32.86-61.85a8,8,0,0,1,6.64,14.56c-6.43,2.93-20.62,12.36-23.12,38.91,26.55-2.5,36-16.69,38.91-23.12a8,8,0,1,1,14.56,6.64Z';

export default Vue.extend({
  name: 'BetaRocketIcon',
  functional: true,
  props: {
    size: { type: Number, default: 24 },
  },
  render (h: CreateElement, { props, data }: RenderContext<IProps>): VNode {
    return h('svg', {
      class: data.class,
      staticClass: data.staticClass,
      attrs: {
        xmlns: 'http://www.w3.org/2000/svg',
        viewBox: '0 0 256 256',
        width: props.size,
        height: props.size,
        fill: 'currentColor',
        'aria-hidden': 'true',
        focusable: 'false',
      },
    }, [
      h('path', { attrs: { d: SECONDARY_PATH, opacity: '0.2' } }),
      h('path', { attrs: { d: PRIMARY_PATH } }),
    ]);
  },
});
</script>
